import { C } from "@hikari/vault-core";

export default function Footer({ onNav }) {
    const link = {
        background: "transparent",
        border: "none",
        color: C.muted,
        fontFamily: C.font,
        fontSize: "0.78rem",
        cursor: "pointer",
        padding: "0.2rem 0",
        textAlign: "left",
    };
    return (
        <footer
            style={{
                borderTop: `1px solid ${C.border}`,
                padding: "3rem 1.5rem 2rem",
                fontFamily: C.font,
                color: C.muted,
                fontSize: "0.78rem",
            }}
        >
            <div
                style={{
                    maxWidth: "960px",
                    margin: "0 auto",
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                    gap: "2rem",
                }}
            >
                <div>
                    <div style={{ color: C.text, marginBottom: "0.75rem", fontWeight: 500 }}>
                        <span style={{ color: C.accent }}>◆</span>&nbsp; Hikari Vault
                    </div>
                    <div style={{ lineHeight: 1.55, color: C.dim }}>
                        A Hikari Brand product.
                        <br />
                        Built for people who don't trust easily.
                    </div>
                </div>
                <div>
                    <div style={{ color: C.text, marginBottom: "0.75rem" }}>Product</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.15rem" }}>
                        <button type="button" style={link} onClick={() => onNav("landing")}>Overview</button>
                        <button type="button" style={link} onClick={() => onNav("security")}>Security model</button>
                        <button type="button" style={link} onClick={() => onNav("landing", "pricing")}>Pricing</button>
                        <button type="button" style={link} onClick={() => onNav("landing", "nonprofit")}>Nonprofit program</button>
                    </div>
                </div>
                <div>
                    <div style={{ color: C.text, marginBottom: "0.75rem" }}>Legal</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.15rem" }}>
                        <button type="button" style={link} onClick={() => onNav("privacy")}>Privacy policy</button>
                        <button type="button" style={link} onClick={() => onNav("terms")}>Terms of service</button>
                        <button type="button" style={link} onClick={() => onNav("landing", "faq")}>FAQ</button>
                    </div>
                </div>
                <div>
                    <div style={{ color: C.text, marginBottom: "0.75rem" }}>Project</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.15rem" }}>
                        <div style={{ color: C.dim }}>Open source (soon)</div>
                        <div style={{ color: C.dim }}>Security audit (soon)</div>
                        <div style={{ color: C.dim }}>Self-host docs (soon)</div>
                        <div style={{ color: C.dim }}>Transparency report</div>
                    </div>
                </div>
            </div>
            <div
                style={{
                    maxWidth: "960px",
                    margin: "2.5rem auto 0",
                    paddingTop: "1.5rem",
                    borderTop: `1px solid ${C.border}`,
                    color: C.dim,
                    fontSize: "0.72rem",
                    letterSpacing: "0.05em",
                    textAlign: "center",
                }}
            >
                © {new Date().getFullYear()} Hikari Brand · We don't know your name, and we'd like to keep it that way.
            </div>
        </footer>
    );
}
